(function () {
  const initSlider = (section) => {
    if (!section?.classList.contains("social-media-section")) return;

    const slider = section.querySelector(".social-media-slider");
    if (!slider || slider.swiper) return;

    const prevBtn = section.querySelector(".social-media-slider__button--prev");
    const nextBtn = section.querySelector(".social-media-slider__button--next");
    const paginationEl = section.querySelector(
      ".social-media-slider__pagination"
    );
    const navEl = section.querySelector(".social-media-slider__nav");
    const slides = slider.querySelectorAll(".swiper-slide");

    const mobileColumnsRaw = slider.dataset.mobileColumns;
    let mobileColumns = parseInt(mobileColumnsRaw || "2", 10);
    if (mobileColumns !== 1 && mobileColumns !== 2) {
      mobileColumns = 2;
    }

    const desktopColumnsRaw = slider.dataset.desktopColumns;
    let desktopColumns = parseInt(desktopColumnsRaw || "4", 10);
    if (!Number.isFinite(desktopColumns)) {
      desktopColumns = 4;
    }
    if (desktopColumns < 4) {
      desktopColumns = 4;
    }
    if (desktopColumns > 6) {
      desktopColumns = 6;
    }

    if (slides.length <= 1) {
      if (navEl) navEl.style.display = "none";
      if (paginationEl) paginationEl.style.display = "none";
      if (prevBtn) prevBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
      return;
    }

    if (navEl) navEl.style.display = "";

    new Swiper(slider, {
      loop: false,
      allowTouchMove: true,
      speed: 600,
      spaceBetween: 8,
      slidesPerView: mobileColumns,
      watchOverflow: true,
      breakpoints: {
        576: {
          slidesPerView: "auto",
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: desktopColumns,
          spaceBetween: 20,
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationEl,
        type: "bullets",
        clickable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  };

  const init = (section) => {
    if (!section?.classList.contains("social-media-section")) return;
    initSlider(section);
  };

  init(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const slider = event.target?.querySelector(".social-media-slider");
    if (slider?.swiper) {
      slider.swiper.destroy(true, true);
    }
  });
})();
